import React, { useContext, useState } from 'react';
import * as S from './styled';
import Form from '../..';
import { ValidityContext } from '../../../../provider/ValidityProvider';

export default function FormValidityDelete() {
  const { setModal, getValidity, setValidity, deleteValidities } =
    useContext(ValidityContext)!.controllers.validity;

  const [loading, setLoading] = useState(false);
  const selectedValidity = getValidity('selected.validity');
  const selectedvalidities = getValidity('selecteds.validities');
  const validityIds =
    selectedValidity !== null ? [selectedValidity] : selectedvalidities;
  const length = validityIds.length;

  const close = () => {
    setModal('single.deleteValidity', false);
    setValidity('selected.validity', null);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    deleteValidities(validityIds)
      .then(() => {
        close();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <S.Form
      style={{
        maxHeight: '30vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <div style={{ marginLeft: '20px' }}>
          {length === 1
            ? 'Tem certeza que deseja excluir a validade?'
            : `Tem certeza que deseja excluir ${length} validades?`}
        </div>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={close}>
          Fechar
        </Form.Button>
        <Form.Button loading={loading}>Excluir</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
